import { useState } from 'react';
import { cleanJson } from './utils/Columns';
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import NewDropdown from './NewDropdown';
import { FaPen, FaTimes, FaTrash } from 'react-icons/fa';
import GenereCsv from './GenereCsv';

const ManageDropdown = ({ type }) => {

    const url = localStorage.getItem('url');
    const [dropdown, setDropdown] = useState(JSON.parse(localStorage.getItem('dropdown')).filter(e => e.type === type));;

    const columns = [
        { name: 'libelle', selector: row => row.libelle, sortable: true, wrap: true },
        {
            name: 'Modifier', cell: row => (<>
                <Button variant='primary' onClick={() => updateDropDown(row)}><FaPen /></Button>
            </>),
        },
        {
            name: 'Suppr', width: '80px', cell: row => (<>
                <Button variant='danger' onClick={() => delDropDown(row)}><FaTrash /></Button>
            </>),
        },
    ];


    const [searchText, setSearchText] = useState('');
    const [dataFiltered, setDataFiltered] = useState(dropdown);
    
    const handleNewType = (field, value) => {
        setDropdown(JSON.parse(localStorage.getItem('dropdown')).filter(e => e.type === type));
    }

    const handleChangesearchText = (e) => {
        const value = e.target.value;
        setSearchText(value);
        filtreAdhs(value);
    };

    const videfiltre = () => {
        const value = '';
        setSearchText(value);
        filtreAdhs(value);
    };

    const filtreAdhs = (value) => {
        if (value.length < 1) {
            setDataFiltered(dropdown);
        } else {
            const filtered = dropdown.filter(item => {
                // must contains all word of value
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });

            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }

    const filtreAdhsFromData = (data, value) => {
        if (value.length < 1) {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => {
                // must contains all word of value
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });

            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }
    const getDropdown = () => {
        console.log('getDropdown');
        return fetch(`${url}GetDropdown`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Réponse du serveur:', data);
                let dropd = JSON.stringify(cleanJson(data.data));
                localStorage.setItem('dropdown', dropd);
                let types = JSON.parse(dropd).filter(e => e.type === type);
                setDropdown(types);
                filtreAdhsFromData(types, searchText);
            })
            .catch(error => console.error('Erreur:', error));
    }

    const updateDropDown = (row) => {
        console.log('updateDropDown', row.libelle);
        //ajoute a types le retour du prompt
        const libelle = prompt('Modifier ' + type, row.libelle);
        if (libelle) {
            if (dropdown.filter(e => e.type === type).find(el => el.libelle.toLowerCase().trim() === libelle.toLowerCase().trim()) === undefined) {
                fetch(`${url}UpdateDropDown`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ ...row, libelle }),
                })
                    .then((response) => response.json())
                    .then(data => {
                        getDropdown().then(() => {
                            handleNewType('field', libelle);                            
                    })})
                    .catch((error) => {
                        console.error('Erreur:', error);
                    });
            } else {
                alert('Ce ' + type + ' : ' + libelle + ' existe déjà');
            }
        }
    }

    const delDropDown = (row) => {
        console.log('delDropDown', row.libelle);
        //ajoute a types le retour du prompt
        if (window.confirm(`Cela supprimera ${row.libelle} de la liste des ${type} mais ne le supprimera pas des adhérents qui l'ont déja utilisé. Confirmez-vous la suppression de ${row.libelle} ?`)) {

            fetch(`${url}DelDropDown`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ...row }),
            })
                .then((response) => response.json())
                .then((data) => {
                    getDropdown().then(() => {
                        handleNewType('field', row.libelle);
                    });
                })
                .catch((error) => {
                    console.error('Erreur:', error);
                });

        }
    }

    return (<>
        <h1>{type}</h1><NewDropdown type={type} field='champ' handleNewType={handleNewType} />

        <DataTable
            columns={columns}
            data={dataFiltered}
            pagination={true}
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            highlightOnHover
            subHeader
            subHeaderComponent={(
                // <div style={{ display: 'flex', alignItems: 'center' }}>

                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>

                    <input
                        type="text"
                        value={searchText}
                        onChange={handleChangesearchText}
                        // onChange={(e) => setSearchText(e.target.value)}
                        placeholder="Rechercher..."
                    />
                    {searchText && <FaTimes className='h-5' onClick={() => videfiltre()} />}                    
                    <div style={{ flexGrow: 1 }} />
                    <GenereCsv data={dataFiltered} fichier="Adherent" visible={true} />
                </div>
            )}
            defaultSortField="id"
            defaultSortAsc={false}
            subHeaderAlign="left"
            noHeader={true}
            paginationComponentOptions={{
                rowsPerPageText: 'Lignes par page:',
            }}
        /></>);

}




export default ManageDropdown;
